export default __webpack_public_path__ + "static/media/screen1.c9d50ecc.png";